var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenContent1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "169.333px",
    height: "138.833px",
    viewBox: "0 0 169.333 138.833",
    enableBackground: "new 0 0 169.333 138.833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F8A99F",
    stroke: "#F8A99F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 36.503,1.667 17.073,56.707 153.409,107.181 167.371,72.868  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F8A99F",
    stroke: "#F8A99F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 19.018,103.375 2.221,98.778 11.812,71.135 28.454,76.649  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F8A99F",
    stroke: "#F8A99F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 94.808,124.122 74.514,118.566 82.938,94.701 102.864,101.302  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD3AF",
    stroke: "#FDD3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 70.76,94.701 31.721,82.902 33.355,78.273 72.101,91.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD3AF",
    stroke: "#FDD3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 67.032,105.261 27.556,94.701 29.174,90.115 68.259,101.787  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD3AF",
    stroke: "#FDD3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 63.409,115.527 24.039,104.663 25.734,99.862 65.051,110.874  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD3AF",
    stroke: "#FDD3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 148.284,119.779 107.177,107.181 108.568,103.192 149.513,116.757  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD3AF",
    stroke: "#FDD3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 144.863,128.186 103.863,116.57 105.658,111.485 146.517,124.122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD3AF",
    stroke: "#FDD3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 141.335,136.857 100.634,125.716 102.49,120.458 143.139,132.423  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenContent1X);
export default __webpack_public_path__ + "static/media/screen_content1x.e34514f5cb39ca3b014390a9fa5688b3.svg";
export { ForwardRef as ReactComponent };